import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getCompanyNameByShortId } from '@/features/auth/api/company.api';
import { logger } from '@/features/help/utils/logger';

// Purpose: Set document.title to "{company}" on public application routes; fallback to a generic title on error
export function useApplicationTitle() {
  const location = useLocation();

  useEffect(() => {
    const defaultTitle = 'Application Portal';
    const path = location.pathname || '';

    // Only run on /application/:userShortId/... routes
    if (!path.startsWith('/application/')) {
      return;
    }

    const parts = path.split('/').filter(Boolean);
    const userShortId = parts[1];

    if (!userShortId) {
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const company = await getCompanyNameByShortId(userShortId);
        if (!cancelled && company) {
          document.title = `${company}`;
        }
      } catch (error) {
        logger.warn('useApplicationTitle', 'Falling back to default title after error', {
          error,
          userShortId,
        });
        if (!cancelled) {
          document.title = defaultTitle;
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [location.pathname]);
}

